<template>
  <div>
    <button class="btn" :class="btnClass" @click="runAnimation" v-if="!animationEnd">Let's get started</button>
    <section class="section section--centered" v-if="isMainEnable">
      <h2 class="section__header">Kamil Woźniak</h2>
      <h4 class="section__subheader">Software developer, third-year CS student at AGH UST</h4>
      <ul>
        <li class="section__link"><a href="mailto:jestem.kamil.wozniak@gmail.com">Contact me </a></li>
        <li class="section__link"><a href="https://www.linkedin.com/in/kamil-woźniak-95332717b/">LinkedIn </a></li>
        <li class="section__link"><a href="https://github.com/valaraucoo">GitHub </a></li>
        <li class="section__link" @click="isAboutEnable = !isAboutEnable">About me</li>
      </ul>
    </section>

    <section class="section" v-if="isAboutEnable">
      <div class="section__header-box"></div>
      <h2 class="section__header">About</h2>
      <span class="section__link section__link--about" @click="isAboutEnable = !isAboutEnable">Back</span>
      <p class="section__paragraph">
        👋 Hey there, my name is Kamil Woźniak, currently I'm the intern as 🐍<b>Python Full Stack Developer</b>.
        I’m passionate about machine learning, artificial intelligence, software development and open source.
      </p>
      <p class="section__paragraph">
        <ul>
          <li class="section__list">🏠 <b>Location:</b> Cracow, 🇵🇱 Poland</li>
          <li class="section__list">🎓 <b>Education:</b> Computer Science (2018 - present), <b>AGH UST</b></li>
          <li class="section__list">⛰️ <b>Hobbies:</b> 🏋️‍♂️ gym, 🎵 music & 🍺 beer</li>
        </ul>
      </p>
      <h4 class="section__title">Profile & Career Objectives👨‍💻</h4>
      <p class="section__paragraph">
        Focused and detail-oriented junior developer with first commercial experience and academic knowledge.
        My goal is to develop my skills and gain new professional experience.
      </p>
      <h4 class="section__title">Work Experience 💡</h4>
      <p class="section__paragraph">
        <span class="section__subtitle">Python Fullstack Developer - SEEDiA City</span> (JUNE 2020 - Present)
        <br>
        Maintenance, development and support of a custom platform and applications, API development using Django,
        creating new subpages, software testing and collaboration with other programmers.
      </p>
      <h4 class="section__title">Technologies ⚡</h4>
      <p class="section__paragraph">
        <ul>
          <li class="section__list"><b>Python</b>  -  Django / Django REST / AI Tools</li>
          <li class="section__list"><b>JavaScript</b>  -  ES6+ / VueJS (Vuex, Vuerouter, Vuetify)</li>
          <li class="section__list"><b>HTML5/CSS3</b> -  Sass / BEM Methodology</li>
          <li class="section__list"><b>Databases</b>  -  PostgreSQL / Firestore (NoSQL)</li>
          <li class="section__list"><b>Version Control</b>  -  Git / GitHub / GitLab</li>
          <li class="section__list"><b>Basics knowledge of</b>  -  AWS / Azure / Terraform / Kubernetes /  InfluxDB / Docker</li>
        </ul>
      </p>
      <h4 class="section__title">Languages 🌎</h4>
      <p class="section__paragraph">
        <ul>
          <li class="section__list"><b>Polish 🇵🇱</b>  -  native</li>
          <li class="section__list"><b>English 🇬🇧</b>  -  B2/C1</li>
        </ul>
      </p>
      <h4 class="section__title">Projects 🧱</h4>
      <p class="section__paragraph">
        You can find my projects on my <a class="section__projects-link" href="https://github.com/valaraucoo">github account</a>.
      </p>
      <div class="repo-grid">
        <div class="repo" v-for="repo in lastRepos" :key="repo.id">
          <a :href="repo.html_url" class="repo__title">{{repo.name}}</a>
          <p class="repo__description">{{repo.description}}</p>
          <p class="repo__lang">{{repo.language}}</p>
        </div>
      </div>
    </section>

    <div class="heart"
     v-for="heart in hearts"
     :key="heart.id"
     @click="heart.isClicked = true"
     :style="{left: heart.left, animationDuration: heart.duration, fontSize: heart.size}"
    >
      <span v-if="heart.isClicked">💚</span>
      <span v-else>💜</span>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";

  export default {
  name: "Home",
  data() {
    return {
      start: false,
      isAnimationRun: false,
      animationEnd: false,
      hearts: [],
      isAboutEnable: false,
    };
  },
  components: {},
  computed: {
    ...mapGetters({
      repos: 'getRepos'
    }),
    lastRepos: function() {
      return this.repos.slice(0,10).filter(repo => repo.description !== null);
    },
    btnClass: function() {
      return {
        'btn--hidden': this.start
      };
    },
    isMainEnable: function () {
      return (this.animationEnd) && (!this.isAboutEnable)
    },
  },
  beforeCreate() {
    this.$store.dispatch('fetchRepos');
  },
    methods: {
    createHeart() {
      if (this.hearts.length < 30) {
        this.hearts.push({
          left: Math.random() * 150 + "vh",
          duration: Math.random() * 2 + 1.5 + "s",
          size: Math.random() * 2 + 1 + "rem",
          isClicked: false
        });
      } else {
        this.animationEnd = true;
      }
    },
    generateHearts() {
      setInterval(this.createHeart, 50);
    },
    runAnimation() {
      this.start = true;
      this.isAnimationRun = true;
      this.generateHearts();
    },
  }
};
</script>

<style lang="sass">
$bg-color: #22223B
$accent: #CA7DF9

li
  z-index: 0

.repo-grid
  margin-top: 1rem
  display: grid
  grid-template-columns: 1fr
  grid-gap: 14px

@media (min-width: 800px)
  .repo-grid
    grid-template-columns: repeat(2, 1fr)

.repo
  box-shadow: 0px 0px 20px -5px rgba(0,0,0,0.75);
  padding: 10px 10px 0 10px
  border-radius: 10px
  display: grid
  grid-template-columns: minmax(75px, 1fr) auto minmax(75px, 1fr)
  grid-template-rows: minmax(40px, 1fr) 1fr minmax(20px, 1fr)
  transition: all .3s ease
  &:hover
    box-shadow: 0px 0px 25px -3px rgba(0,0,0,0.75);
    background-color: lighten($bg-color, 3)
    .repo__title
      color: lighten($accent, 10)
      &:hover
        color: $accent
  &__title
    font-size: .9rem
    font-weight: 800
    text-align: center
    grid-column: 1 / 5
    transition: color .3s ease
  &__description
    font-size: .7rem
    grid-column: 1/5
  &__lang
    font-size: .6rem
    grid-column: 4/5
    font-weight: 800

.section
  max-width: 700px
  width: 90vw
  color: #fff
  font-family: 'Fira Code', monospace
  padding: 15px
  margin-bottom: 20vh
  &--centered
    transform: translateX(15%)
  &__header-box
    z-index: 1000
    width: 100%
    height: 85px
    position: fixed
    background-color: $bg-color
    top: 0
    left: 0

  &__header
    position: sticky
    z-index: 1000
    top: 5px
    font-size: 3rem
    animation: appear .5s ease
  &__subheader
    font-size: .8rem
    animation: appear .7s ease
  &__paragraph
    margin-top: .2rem
    font-size: .8rem
    animation: appear .7s ease
    &:first-of-type
      margin-top: 2rem
  &__projects-link
    color: $accent
    transition: color .3s ease
    &:hover
      color: darken($accent, 15)
  &__title
    margin-top: 2rem
    font-size: 1.1rem
    font-weight: bolder
    animation: appear .7s ease
  &__subtitle
    font-weight: bolder
    font-size: .9rem
    margin: 0 15px 0 15px
    position: relative
    &::before
      content: '>'
      position: absolute
      top: -2px
      left: 0
      transform: translateX(-15px)
      transition: transform .3s ease
  &__list
    position: relative
    animation: linkAppear .7s ease both
    font-size: .8rem
    margin: 0 15px 0 15px
    &::before
      content: '>'
      position: absolute
      top: 0
      left: 0
      transform: translateX(-15px)
      transition: transform .3s ease
  &__link
    display: inline-block
    animation: linkAppear 1.2s .5s ease both
    font-size: .8rem
    font-weight: 800
    margin: 0 15px 0 15px
    position: relative
    transition: color .3s ease
    &--about
      position: sticky
      z-index: 1000
      top: 60px
      cursor: pointer
    &:hover
      color: $accent
      &::before
        transform: translateX(-15px) rotate(360deg)
    &::before
      content: '>'
      position: absolute
      top: 0
      left: 0
      transform: translateX(-15px)
      transition: transform .3s ease
    &:nth-child(2)
      animation-delay: .75s
    &:nth-child(3)
      animation-delay: 1s
    &:nth-child(4)
      cursor: pointer
      animation-delay: 1.25s
@media screen and (max-width: 600px)
  .section__header
    font-size: 2rem
  .section__title
    margin-top: 3rem
  .section--centered
    transform: none

.btn
  position: relative
  font-size: 16px
  font-weight: 500
  border-radius: 5px
  text-transform: uppercase
  background-color: white
  padding: 10px 30px
  border: none
  transition: transform .3s ease-out, all .4s

  &--hidden
    opacity: 0
    transform: translateY(200px)

  &::after
    content: "💜"
    font-weight: 200
    position: absolute
    left: 70%
    top: 22%
    right: 10%
    opacity: 0
    transition: all .3s


  &:hover
    background-color: $accent
    color: #fff
    padding: 10px 50px 10px 30px
    box-shadow: 0px 0px 63px -14px rgba(255,23,255,1)

    &::after
      transform: translateX(10px)
      opacity: 1

.heart
  position: fixed
  font-size: 2rem
  top: -8vh
  transform: translateY(0)
  animation: fall 3s ease-in forwards
  transition: transform .3s ease

@keyframes appear
  from
    transform: translateY(100px)
    opacity: 0
  to
    transform: translateY(0)
    opacity: 1

@keyframes linkAppear
  from
    transform: translateX(-100px)
    opacity: 0
  to
    transform: translateX(0)
    opacity: 1

@keyframes fall
  to
    transform: translateY(120vh)
</style>
